import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const ClearUrlPromoCode = (repository: StoragePromoCodeRepository) => (): void => {
  repository.removePromoUrl();
};

export {ClearUrlPromoCode};
